import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconHiperlink: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M13.6472 6.11765C13.0624 6.11765 12.5884 5.6436 12.5884 5.05882C12.5884 4.47405 13.0624 4 13.6472 4H18.9413C19.5261 4 20.0001 4.47405 20.0001 5.05882V10.3529C20.0001 10.9377 19.5261 11.4118 18.9413 11.4118C18.3565 11.4118 17.8825 10.9377 17.8825 10.3529V7.61505L12.2782 13.2193C11.8647 13.6328 11.1943 13.6328 10.7808 13.2193C10.3673 12.8058 10.3673 12.1354 10.7808 11.7219L16.3851 6.11765H13.6472Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4 6C4 4.89543 4.89543 4 6 4H8.93506C9.48735 4 9.93506 4.44772 9.93506 5C9.93506 5.55228 9.48735 6 8.93506 6H7C6.44772 6 6 6.44772 6 7V16.9412C6 17.4935 6.44772 17.9412 7 17.9412H16.94C17.4923 17.9412 17.94 17.4935 17.94 16.9412V14.9412C17.94 14.3889 18.3877 13.9412 18.94 13.9412C19.4923 13.9412 19.94 14.3889 19.94 14.9412V17.9412C19.94 19.0457 19.0446 19.9412 17.94 19.9412H6C4.89543 19.9412 4 19.0457 4 17.9412V6Z',
    })
  )
}
